import ReplayIcon from "@mui/icons-material/Replay";
import { nacidRequests } from "api/nacidApi";
import { useNotify, useRecordContext, useRefresh } from "react-admin";
import dataProvider from "server/dataProvider";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { Button } from "@mui/material";

// Re-arms every step that failed, exhausted its retries, was cancelled or parked on a human, and queues the
// flow. Steps NACID already accepted are deliberately left alone by the backend — re-sending one is the
// duplicate NACID rejects rather than absorbs.
const RetryFlowDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  // No try/catch: ConfirmModal catches, notifies and keeps itself open. A 409 here surfaces the backend's
  // EC_Nacid_Flow_Not_Retryable through errorMessages.js.
  const handleConfirm = async () => {
    await dataProvider.customRequest(nacidRequests.retryFlow(record.id), null, "POST");

    notify("Потокът е пуснат отново.", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleConfirm}
      titleContent="Пускане на потока отново"
      message={
        "Стъпките, които са неуспешни, изчерпали опитите си, отказани или чакащи ръчна намеса, ще бъдат " +
        "нулирани и потокът ще бъде изпълнен отново. Вече успешните стъпки не се повтарят."
      }
      saveTitle="Пусни отново"
      triggerButton={
        <Button
          label="Пусни отново"
          startIcon={<ReplayIcon />}
        />
      }
    />
  );
};

export default RetryFlowDialog;
